// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as AutoCreateTicketApiModel from "../entity/AutoCreateTicketApiModel.bs.js";

function decodeAutoCreateTicketRes(param) {
  return {
          crt_id: param.crt_id,
          ticket_id: param.case_number
        };
}

function execute(data) {
  return decodeAutoCreateTicketRes(DeccoUtils$Catalyst.resolveResult(AutoCreateTicketApiModel.t_decode(data), "AutoCreateTicketEntityMapper.re"));
}

export {
  decodeAutoCreateTicketRes ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
